
import { configureStore,combineReducers } from "@reduxjs/toolkit";
import {apiSlice} from "./slice/api";
//import { userkeycloakReducer } from "./slice/keycloakUser";
import { persistStore ,persistReducer } from 'redux-persist';
import sessionStorage from "redux-persist/lib/storage/session"
import authSlice from "./slice/auth.slice";
import compteSlice from "./slice/compte.slice";

const persistConfig = {
  key: "root", // La clé sous laquelle les données sont stockées dans le stockage local
  storage: sessionStorage, // Le système de stockage à utiliser (localStorage par défaut)
  whitelist: ["other"], 
};

const rootReducer = combineReducers({
    [apiSlice.reducerPath]:apiSlice.reducer,
    //userOidc: userkeycloakReducer,
    auth: authSlice,
    compte: compteSlice,
  })

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer, //
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"]
      },
    }).concat(apiSlice.middleware),
})

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof rootReducer>;

export default store;